// extracted by mini-css-extract-plugin
module.exports = {"gridGroup":"gridGroup_gridGroup__3sxcy"};